/*
 * Action Types
 */
export enum BugReportsTypes {
  LIST_BUG_REPORTS_REQUEST = '@bugReports/LIST_BUG_REPORTS_REQUEST',
  LIST_BUG_REPORTS_SUCCESS = '@bugReports/LIST_BUG_REPORTS_SUCCESS',
  LIST_BUG_REPORTS_FAILURE = '@bugReports/LIST_BUG_REPORTS_FAILURE',

  GET_BUG_REPORT_REQUEST = '@bugReports/GET_BUG_REPORT_REQUEST',
  GET_BUG_REPORT_SUCCESS = '@bugReports/GET_BUG_REPORT_SUCCESS',
  GET_BUG_REPORT_FAILURE = '@bugReports/GET_BUG_REPORT_FAILURE',

  FILTER_BUG_REPORTS_REQUEST = '@bugReports/FILTER_BUG_REPORTS_REQUEST',
  FILTER_BUG_REPORTS_SUCCESS = '@bugReports/FILTER_BUG_REPORTS_SUCCESS',
  FILTER_BUG_REPORTS_FAILURE = '@bugReports/FILTER_BUG_REPORTS_FAILURE',

  CREATE_BUG_REPORT_REQUEST = '@bugReports/CREATE_BUG_REPORT_REQUEST',
  CREATE_BUG_REPORT_SUCCESS = '@bugReports/CREATE_BUG_REPORT_SUCCESS',
  CREATE_BUG_REPORT_FAILURE = '@bugReports/CREATE_BUG_REPORT_FAILURE',

  UPDATE_BUG_REPORT_REQUEST = '@bugReports/UPDATE_BUG_REPORT_REQUEST',
  UPDATE_BUG_REPORT_SUCCESS = '@bugReports/UPDATE_BUG_REPORT_SUCCESS',
  UPDATE_BUG_REPORT_FAILURE = '@bugReports/UPDATE_BUG_REPORT_FAILURE',

  DELETE_BUG_REPORT_REQUEST = '@bugReports/DELETE_BUG_REPORT_REQUEST',
  DELETE_BUG_REPORT_SUCCESS = '@bugReports/DELETE_BUG_REPORT_SUCCESS',
  DELETE_BUG_REPORT_FAILURE = '@bugReports/DELETE_BUG_REPORT_FAILURE',
}

/*
 * Data types
 */
export interface BugReportInterface {
  id: string;
  title: string;
  description: string;
  version: string;
  lastUpdatedBy: string;
  fixComment: string;
  fixVersion: string;
  photoUrl: string;
  status: number;
  createdAt: string;
}

/*
 * State type
 */
export interface BugReportsState {
  readonly bugReportsList: BugReportInterface[];
  readonly bugReportData: BugReportInterface;
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
}
